export default __webpack_public_path__ + "static/media/안주11.93b44439.png";